/**
 * Navigation menu toggle
 *
 * The navigation menu animation is handled by jQuery. However, when it is not
 * being animated, the visible/hidden state is controlled by styles in the main
 * CSS. This allows us to use media queries to always display the navigation on
 * large enough screens regardless of whether or not they have been toggled on
 * small screens.
 *
 * This also adds and removes classes on the navigation toggle control, which
 * affect the appearance of the SVG icon inside that element.
 */
$(function() {
    var nav = $('.page-header .nav');
    var toggle = $('.page-header .nav-toggle');
    var duration = 300;

    if (nav.length === 0) {
        return;
    }

    toggle.on('click', function(e) {
        e.preventDefault();

        // As the animation starts, add a class to the toggle control that hides
        // the SVG icon by making it very small.
        toggle.addClass('transition');

        // If the menu is already hidden, slide it open with jQuery and remove
        // the custom hidden class.
        if (nav.hasClass('hidden')) {
            return nav.hide().slideDown(duration, function() {

                // When the menu animation is finished, switch the toggle
                // control icon and remove the transition class to make it
                // visible again.
                toggle.removeClass('transition show').addClass('hide');
            }).removeClass('hidden');
        }

        // Otherwise, slide it closed with jQuery, then swap the inline jQuery
        // styles for the styles attached to the hidden class in the CSS.
        nav.slideUp(duration, function() {
            nav.removeAttr('style').addClass('hidden');

            // When the menu animation is finished, switch the toggle control
            // icon and remove the transition class to make it visible again.
            toggle.removeClass('transition hide').addClass('show');
        });
    });

    // The navigation should be hidden on page load
    nav.addClass('hidden');
    toggle.addClass('show')
});
